import { Permission, PermissionType } from "../types";
import { supabase } from "@/integrations/supabase/client";

interface AuditEntry {
  changed_by_user_id: string;
  changed_by_user_name: string;
  company: string;
  role: string;
  resource: string;
  permission_type: string;
  old_value: boolean;
  new_value: boolean;
}

/**
 * Compare old and new permissions and log the differences to the audit table
 */
export const logPermissionChanges = async (
  oldPermissions: Permission[],
  newPermissions: Permission[],
  userId: string,
  userName: string
): Promise<void> => {
  const changes: AuditEntry[] = [];
  const permissionTypes: PermissionType[] = ["read", "write", "delete"];

  for (const newPerm of newPermissions) {
    const oldPerm = oldPermissions.find(
      (p) => p.role === newPerm.role && p.resource === newPerm.resource && p.company === newPerm.company
    );

    for (const type of permissionTypes) {
      const oldVal = oldPerm ? oldPerm[type] : false;
      const newVal = newPerm[type];

      if (oldVal !== newVal) {
        changes.push({
          changed_by_user_id: userId,
          changed_by_user_name: userName,
          company: newPerm.company,
          role: newPerm.role,
          resource: newPerm.resource,
          permission_type: type,
          old_value: oldVal,
          new_value: newVal,
        });
      }
    }
  }

  if (changes.length === 0) return;

  try {
    const { error } = await supabase
      .from("role_permission_audit_log")
      .insert(changes);

    if (error) {
      console.error("[AuditLogger] Failed to log permission changes:", error);
    } else {
      console.log(`[AuditLogger] Logged ${changes.length} permission change(s)`);
    }
  } catch (err) {
    console.error("[AuditLogger] Error logging permission changes:", err);
  }
};
